import { MobileBody } from "./MobileBody/MobileBody";
import { MobileFooterNavbar } from "./MobileFooterNavbar/MobileFooterNavbar";
import "./MobileApp.scss";
import { ErrorBoundary } from "react-error-boundary";
import ErrorComponent from "./components/ErrorComponent";
import { useUser } from "../common/contexts/userContext";
import { useNavigate } from "react-router-dom";
import HomePageHeader from "./HomePageHeader";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { useFixtures } from "../common/contexts/fixturesContext";
import { useBets } from "../common/contexts/betContext";
import { getAllMatches } from "../services/matchService";
import { getUserBets } from "../services/betService";
import { getUserById } from "../services/userService";
import { isSigned, getToken } from "../services/authStorage";
import { DecodedToken } from "../types/DecodedToken";

export const MobileApp = () => {
  const navigate = useNavigate(); // used to re-render component and actualize isNavbarVisibile variable
  const isNavbarVisible =
    isSigned() &&
    !["/createAccount", "/login"].includes(window.location.pathname);
  const isHeaderVisible =
    isSigned() &&
    !["/login", "/createAccount", "/", "/createLeague"].includes(
      window.location.pathname
    );

  const { user, setUser, setIsLoading: setUserLoading } = useUser();
  const { setMatches, setIsLoading: setMatchesLoading } = useFixtures();
  const { setBets, setIsLoading: setBetsLoading } = useBets();

  async function updateContexts(token: DecodedToken) {
    setUserLoading(true);
    setMatchesLoading(true);
    setBetsLoading(true);
    try {
      const [matches, bets, userData] = await Promise.all([
        getAllMatches(),
        getUserBets(token.Id),
        getUserById(token.Id),
      ]);
      setMatches(matches.filter((match) => match.homeTeam && match.awayTeam));
      setBets(bets);
      setUser(userData);
    } finally {
      setUserLoading(false);
      setMatchesLoading(false);
      setBetsLoading(false);
    }
  }

  useEffect(() => {
    if (isSigned() && !user.id) {
      const tokenDecoded = jwtDecode<DecodedToken>(getToken() ?? "");
      updateContexts(tokenDecoded);
    }
    // Run-once bootstrap: hydrate user/matches/bets for an existing session.
    // updateContexts is recreated each render, so listing it (or the guard
    // values) would re-run this effect and risk a refetch loop — mount-only is
    // intentional.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="mobileAppLayout">
      {isHeaderVisible && <HomePageHeader />}
      <div className="mobileAppLayout__body">
        <ErrorBoundary
          FallbackComponent={ErrorComponent}
          onReset={() => navigate("/")}
        >
          <MobileBody />
        </ErrorBoundary>
      </div>
      {isNavbarVisible ? <MobileFooterNavbar /> : null}
    </div>
  );
};
